module.exports = __webpack_public_path__ + "722d05754bd671ec17e5718f52697235.jpg";